import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button, Flex, Heading } from '@chakra-ui/react'
import { FC } from 'react'
import { Helmet } from 'react-helmet'
import Lottie from 'react-lottie'

import Animation from '../animations/not-found.json'

const NotFoundAuth: FC = () => {
  const { loginWithRedirect } = useAuth0()
  return (
    <>
      <Helmet>
        <title>manutencao - SCL</title>
      </Helmet>
      <Box bg="green.600" h="100vh" overflowY="auto" color="gray.800">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          bg="green.600"
          borderRadius="8px"
          h="calc(100vh - 8px)"
          p={6}
        >
          <Lottie
            width={900}
            options={{
              loop: true,
              autoplay: true,
              animationData: Animation
            }}
          />

          <Heading
            mb={5}
            fontSize={['40px', '40px', '50px']}
            fontWeight="800"
            color="white"
          >
            Oops! Página nao encontrada
          </Heading>

          <br></br>
          <Button
            backgroundColor={'yellow.100'}
            onClick={() => loginWithRedirect()}
          >
            Acessa a aplicacao
          </Button>
        </Flex>
      </Box>
    </>
  )
}

export default NotFoundAuth
